import { Injectable, Signal, signal, WritableSignal } from '@angular/core';

/** Tracks whether the current session has expired (HTTP 401) and the user must sign in again. */
@Injectable({ providedIn: 'root' })
export class SessionExpiredService {
  private readonly _isSessionExpired: WritableSignal<boolean> = signal<boolean>(false);

  /** True when a recent API call returned HTTP 401 Unauthorized. */
  public readonly isSessionExpired: Signal<boolean> = this._isSessionExpired.asReadonly();

  /** Marks the session as expired so the app can prompt for re-login. */
  public markSessionExpired(): void {
    this._isSessionExpired.set(true);
  }

  /** Clears the session-expired state after a successful sign-in. */
  public clear(): void {
    this._isSessionExpired.set(false);
  }
}
